import React from 'react'

export default function ReviewGrid(props) {

  const {reviews} = props

  return (
    <div className="reviewgrid">

    </div>
  )
}